/**
 * Junta classes condicionais descartando `false`, `null` e `undefined`.
 *
 * Sem isto, o padrao do prototipo — template string com ternario dentro —
 * produz espacos duplos e classes vazias, e fica ilegivel assim que ha mais de
 * duas condicoes.
 */
export function cn(...parts: Array<string | false | null | undefined>): string {
  return parts.filter(Boolean).join(" ")
}
